// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container chung */
.payment-container {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f7f9fc;
    font-family: Arial, sans-serif;
    padding: 20px;
    box-sizing: border-box;
}

.payment-card {
    background: #ffffff;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    padding: 20px;
    width: 100%;
    max-width: 1000px;
    text-align: center;
}

.payment-title {
    font-size: 1.5rem;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
}

.payment-status {
    font-size: 1.2rem;
    margin-bottom: 15px;
}

.payment-status.success {
    color: #28a745; 
    font-weight: bold;
}

.payment-status.pending {
    color: #dc3545; 
    font-weight: bold;
}

.payment-info {
    font-size: 1rem;
    color: #555;
    margin-bottom: 10px;
}

.transaction-details {
    text-align: left;
    margin-top: 15px;
    background: #f8f9fa;
    padding: 15px;
    border-radius: 6px;
}

.transaction-details h4 {
    font-size: 1.2rem;
    color: #333;
    margin-bottom: 10px;
}

.transaction-details p {
    font-size: 1rem;
    color: #555;
    margin: 5px 0;
}

.transaction-details strong {
    font-weight: bold;
    color: #333;
}


@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}


/* PayPalConfirmPayment.css */
.loading-spinner {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh; /* Chiều cao toàn màn hình */
}

.spinner {
    width: 50px;
    height: 50px;
    border: 5px solid rgba(0, 0, 0, 0.1);
    border-top-color: #007bff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/PageStatus/PayPalConfirmPayment.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,8BAA8B;IAC9B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;;AAGA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;;AAGA,6BAA6B;AAC7B;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa,EAAE,4BAA4B;AAC/C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,yBAAyB;IACzB,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":["/* Container chung */\n.payment-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #f7f9fc;\n    font-family: Arial, sans-serif;\n    padding: 20px;\n    box-sizing: border-box;\n}\n\n.payment-card {\n    background: #ffffff;\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n    padding: 20px;\n    width: 100%;\n    max-width: 1000px;\n    text-align: center;\n}\n\n.payment-title {\n    font-size: 1.5rem;\n    font-weight: bold;\n    color: #333;\n    margin-bottom: 20px;\n}\n\n.payment-status {\n    font-size: 1.2rem;\n    margin-bottom: 15px;\n}\n\n.payment-status.success {\n    color: #28a745; \n    font-weight: bold;\n}\n\n.payment-status.pending {\n    color: #dc3545; \n    font-weight: bold;\n}\n\n.payment-info {\n    font-size: 1rem;\n    color: #555;\n    margin-bottom: 10px;\n}\n\n.transaction-details {\n    text-align: left;\n    margin-top: 15px;\n    background: #f8f9fa;\n    padding: 15px;\n    border-radius: 6px;\n}\n\n.transaction-details h4 {\n    font-size: 1.2rem;\n    color: #333;\n    margin-bottom: 10px;\n}\n\n.transaction-details p {\n    font-size: 1rem;\n    color: #555;\n    margin: 5px 0;\n}\n\n.transaction-details strong {\n    font-weight: bold;\n    color: #333;\n}\n\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(-10px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n\n/* PayPalConfirmPayment.css */\n.loading-spinner {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh; /* Chiều cao toàn màn hình */\n}\n\n.spinner {\n    width: 50px;\n    height: 50px;\n    border: 5px solid rgba(0, 0, 0, 0.1);\n    border-top-color: #007bff;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
